/* tslint:disable */

declare var Object: any;
export interface ERPsalesBadDebtInterface {
  "id"?: number;
}

export class ERPsalesBadDebt implements ERPsalesBadDebtInterface {
  "id": number;
  constructor(data?: ERPsalesBadDebtInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPsalesBadDebt`.
   */
  public static getModelName() {
    return "ERPsalesBadDebt";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPsalesBadDebt for dynamic purposes.
  **/
  public static factory(data: ERPsalesBadDebtInterface): ERPsalesBadDebt{
    return new ERPsalesBadDebt(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPsalesBadDebt',
      plural: 'ERPsalesBadDebts',
      path: 'ERPsalesBadDebts',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPsalesBadDebt.ts